module.exports = __webpack_public_path__ + "6a96d1335e07ca2a0d997e63625ce886.pdf";